import { checkPrivileges } from "../../Helpers";

export const userRowDefinition = (translate) => {
  const columns = [
    { id: "userType", type: "symbol", numeric: false, disablePadding: false, label: translate("symbol") },
    { id: "name", numeric: false, disablePadding: false, label: translate("sharedName") },
    { id: "email", numeric: false, disablePadding: false, label: translate("userEmail") },
    { id: "roleName", numeric: false, disablePadding: false, label: translate("roleName") },
    { id: "parentName", numeric: false, disablePadding: false, label: translate("parentName") },
    { id: "accountName", numeric: false, disablePadding: false, label: translate("accountName") },
  ];
  if (!localStorage.getItem("adminToken")) {
    columns.push({
      id: "loginAsUser",
      numeric: false,
      disablePadding: false,
      label: translate("loginAsUser"),
    });
  }
  columns.push(
    { id: "created", numeric: false, disablePadding: false, label: translate("createdAt") },
    { id: "changeContract", numeric: false, disablePadding: false, label: translate("changeContract") },
  );
  if (checkPrivileges("userStatusViewOnly")) {
    columns.push({
      id: "userStatus",
      numeric: false,
      disablePadding: false,
      label: translate("accountStatus"),
    });
  }
  return columns;
};

export const accountRowDefinition = (translate) => {
  const columns = [
    { id: "name", numeric: false, disablePadding: false, label: translate("sharedName") },
    { id: "email", numeric: false, disablePadding: false, label: translate("accountEmail") },
    { id: "contractNumber", numeric: false, disablePadding: false, label: translate("contractNumber") },
    { id: "contractName", numeric: false, disablePadding: false, label: translate("contractName") },
    { id: "creditLimit", numeric: false, disablePadding: false, label: translate("creditLimit") },
    { id: "creditPeriod", numeric: false, disablePadding: false, label: translate("creditPeriod") },
    { id: "contractStartDate", numeric: false, disablePadding: false, label: translate("contractStartDate") },
    { id: "contractEndDate", numeric: false, disablePadding: false, label: translate("contractEndDate") },
  ];
  if (checkPrivileges("accountStatusViewOnly")) {
    columns.push({
      id: "active",
      numeric: false,
      disablePadding: false,
      label: translate("accountStatus"),
    });
  }
  return columns;
};

export const setPagination = (pageData, pageSize, rowCount) => {
  if (!pageData || !rowCount) return {};
  const lastPage = Math.max(1, Math.ceil((pageData.total || 0) / pageSize));
  return {
    ...pageData,
    page: pageData.page || 1,
    pageSize,
    lastPage,
    hasNext: (pageData.page || 1) < lastPage,
  };
};
